import * as React from "react";
const IconTick = (props) => (
  <svg
    width={22}
    height={21}
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.86133 11.3674L7.94695 13.8359C8.67085 14.415 9.72077 14.3292 10.3409 13.6401L17.1113 6.11743"
      stroke="#1C1C2C"
      strokeWidth={1.3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconTick;
